import { Component } from "@angular/core";

@Component({
    selector: 'app-invoices',
    templateUrl: './invoices.component.html',
    styleUrls: ['./invoices.component.css']
})

export class InvoicesComponent {

}